import {
    createStore,
    applyMiddleware,
    compose,
  } from 'redux';
  import thunk from 'redux-thunk';
  import createSagaMiddleware from 'redux-saga';
  import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
  import rootReducer from '../reducers';
  import initSagas from './initSagas';
  // import {
  //   dispatcherMiddleware,
  // } from '../middleware/dispatcherMiddleware';
  // import {
  //   hydrationOrchestrationMiddleware,
  // } from '../middleware/hydrationOrchestrationMiddleware';
  
  // =========================================================
  // Saga error handling to catch any unhandled errors in Saga
  // =========================================================
  // eslint-disable-next-line no-console
  const onError = (error) => console.log('Uncaught Global Saga Error:', error);
  
  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  
  const sagaMiddleware = createSagaMiddleware({
    onError,
  });
  
  // const hydrationMiddleware = [
  //   dispatcherMiddleware,
  //   hydrationOrchestrationMiddleware,
  // ];
  
  const middlewares = [sagaMiddleware, thunk];
  
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(reduxImmutableStateInvariant({
      ignore: [
        'storeSearch.sku.history', // kludgey, but store search modal seems to require this
      ],
    }));
  }
  
  const configureStore = (initialState = {}) => {
    const store = createStore(
      rootReducer,
      initialState,
      composeEnhancers(applyMiddleware(...middlewares)),
    );
    initSagas(sagaMiddleware);
  
    return store;
  };
  
  export default configureStore;